module.exports = __webpack_public_path__ + "img/holdem-n.bd974053.png";